/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import LineFull from '../images/linefull.jpg';
import Greenlogo from '../images/greenlogo.jpg';
import SEO from '../components/seo';
import '../styles/app.scss';

const openplay = ({ data }) => {
    const { wordpressPage: post } = data;
    const test_title = post.yoast_title;
    //const new_seo_title = test_title.replace('&#039;', "'");

    return (
        <>
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />
            <section className="page-section smallestwdt">
                <div className="container">
                <h2 className="bluetxt openplaytxt">
                        All Open Play sessions must be booked.
                        </h2>
                    <div className="openplft">
                 {/*       <img
                            src={
                                post.acf.open_play_image_left.localFile
                                    .childImageSharp.fluid.src
                            }
                            alt="nonprofitimg"
                            loading="lazy"
                        /> */}
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: 0,
                                paddingTop: '140.0000%',
                                paddingBottom: 0,
                                boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
                                marginTop: '1.6em',
                                marginBottom: '0.9em',
                                overflow: 'hidden',
                                borderRadius: '8px',
                                willChange: 'transform',
                            }}
                        >
                            <iframe
                                loading="lazy"
                                style={{
                                    display: 'block',
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    top: 0,
                                    left: 0,
                                    border: 'none',
                                    padding: 0,
                                    margin: 0,
                                }}
                                src="https://www.canva.com/design/DAHTQSqnZfU/DICx8bSJG-N2tKc7nM6axw/view?embed"
                                allowFullScreen
                                allow="fullscreen"
                                title="Canva design embed"
                            />
                        </div>
						<p><a href="https://werockthespectrumgeelongym.wrtsfranchise.com/wp-content/uploads/2020/06/WRTS-Geelong-Social-Story.pdf" class="wrtsbtn yellowbtn fullbtn mt-5" target="_blank">View Our Social Story</a></p>
						
				{/*		<h5 className="bluetxt ttl9390">Low Capacity Open Play</h5>
						<iframe src="https://werockthespectrumgeelongym.wrtsfranchise.com/appointments-lowcapacity.php" className="healcode_widgets iframeshow" /> */}
						 
						
                    </div>
                    <div
                        className="openprgt"
                        dangerouslySetInnerHTML={{
                            __html: post.acf.open_play_content_right,
                        }}
                    />
                    <div className="clearall"></div>
                </div>
            </section>
            <div className="container text_center mt-15">
                <img src={LineFull} alt="linefull" loading="lazy" />
            </div>
            <section className="page-section openphours">
                <div className="container smallestwdt">
                    <div className="twothirdcol">
                        <h2
                            className="bluetxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.open_play_schedule_title,
                            }}
                        />
                        <p className='open-new-pp'>
                        <span><strong>Geelong's Open Play Schedule changes daily due to the nature of the services we offer and the other bookings that may be in place</strong></span>. Our opening hours are 9:30am-5:30pm, 7 days per week. We often have special events or programs that can run outside of these hours - it is best to give us a call on 0490 430 444 to find out more information! Bookings are essential.
                        </p>
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: 0,
                                paddingTop: '100.0000%',
                                paddingBottom: 0,
                                boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
                                marginTop: '1.6em',
                                marginBottom: '0.9em',
                                overflow: 'hidden',
                                borderRadius: '8px',
                                willChange: 'transform',
                            }}
                        >
                            <iframe
                                loading="lazy"
                                style={{
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    top: 0,
                                    left: 0,
                                    border: 'none',
                                    padding: 0,
                                    margin: 0,
                                }}
                                src="https://www.canva.com/design/DAHSsZ0XqSw/fc4k0WOlHp-1Emm6YLArug/view?embed"
                                allowFullScreen
                                allow="fullscreen"
                                title="Canva design embed"
                            />
                        </div>

                        {/* <ul className="startxt starlistspacing">
                            {post.acf.open_play_schedule_work_days.map(
                                (schedule, i) => (
                                    <li className="greentxt" key={i}>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    schedule.open_play_schedule_day,
                                            }}
                                        />
                                        : 
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    schedule.open_play_schedule_time,
                                            }}
                                        />
                                    </li>
                                )
                            )}
                            {post.acf.open_play_schedule_weekend.map(
                                (schedule, i) => (
                                    <li className="bluetxt" key={`ii_${i}`}>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    schedule.open_play_schedule_weekend_day,
                                            }}
                                        />
                                        :
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    schedule.open_play_schedule_weekend_time,
                                            }}
                                        />
                                    </li>
                                )
                            )}
                            <p
                                className="pleasecallp"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf
                                            .open_play_please_call_ahead_text,
                                }}
                            />
                        </ul> */}
                    </div>

                    <div className="onethirdcol">
                        <h6
                                className="greentxt"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        post.acf.open_play_registration_title,
                                }}
                            />
                        <a
                            href="https://ecom.roller.app/werockthespectrumgeelong/openplay/en/home"
                            className="wrtsbtn yellowbtn fullbtn"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ padding: '30px', fontSize: '28px' }}
                        >
                            Book Open Play
                        </a>
                        <h2 className='bluetxt'>Sensory Open Play Pricing</h2>
                        <p className='open-new-pp'>
                        <strong>WEEKDAYS:</strong><br/>
                        - $20 per child/participant<br/>
                        - $10 per crawling participant**<br/>
                        - $10 per accompanying therapist (OT, Speech, Physio, etc)<br/>
                        <br/>
                        <strong>WEEKENDS & PUBLIC HOLIDAYS:</strong><br/>
                        - $25 per child/participant<br/>
                        - $15 per crawling participant**<br/>
                        - $10 per accompanying therapist (OT, Speech, Physio, etc)<br/><br/>
                        **Bookings are essential for all children over the age of 6 months as we have toys and equipment to cater for everyone. Please make a booking per attending child.<br/><br/>
                        Children’s tickets include the accompanying parent or guardian. There is no need to book a ticket unless you are an accompanying therapist.
                        </p>
                        <h2 className='bluetxt'>General Open Play Pricing</h2>
                        <p className='open-new-pp'>
                        <strong>WEEKDAYS:</strong><br/>
                        - $12 per child/participant<br/>
                        - $5 per crawling participant**<br/>
                        <br/>
                        <strong>WEEKENDS & PUBLIC HOLIDAYS:</strong><br/>
                        - $15 per child/participant<br/>
                        - $5 per crawling participant**<br/>
                        <br/>
                        NDIS Pricing Options are not available for General Open Play sessions.<br/><br/>
                        **Bookings are essential for all children over the age of 6 months as we have toys and equipment to cater for everyone. Please make a booking per attending child.<br/>                        
                        </p>
                        {/* {post.acf.open_play_register_widget_codes.map(
                            (scheduleCode, i) => (
                                <div
                                    className="healwrap"
                                    key={`key_${i}`}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            scheduleCode.open_play_register_widget_code,
                                    }}
                                />
                            )
                        )} */}
                    </div>
                </div>
            </section>

       {/*     <section
                className="whywelist page-section bg-primary text-white"
                id="openpbasic"
            >
                <div className="container flexwrap whywebluelist">
                    <div className="whylistlft flexbox whylisttxt todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                post.acf.open_play_basic_info_image.localFile
                                    .childImageSharp.fluid.src
                            }
                            loading="lazy"
                            alt="open img"
                        />
                    </div>

                    <div className="whylistrgt flexbox toup">
                        <h2
                            className="yellowtxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.open_play_basic_info_title,
                            }}
                        />
                        <ul
                            className="startxt normalfontlist"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.open_play_basic_info_content,
                            }}
                        />
                    </div>
                </div>
            </section>

            <section className="page-section bg-secondary text-white centersec">
                <div className="container smallestwdt">
                    <h2
                        className="yellowtxt"
                        dangerouslySetInnerHTML={{
                            __html: post.acf.open_play_membership_title,
                        }}
                    />
                    <p
                        className="biggertxt"
                        dangerouslySetInnerHTML={{
                            __html: post.acf.open_play_membership_description,
                        }}
                    />

                    {post.acf.open_play_membership_list.map((membership, i) => (
                        <h5 key={`kt_${i}`}>
                            <span
                                className="yellowtxt"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        membership.open_play_membership_name,
                                }}
                            />
                            {' : '}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html:
                                        membership.open_play_membership_price,
                                }}
                            />
                        </h5>
                    ))}
                </div>
            </section> */}

            <section className="page-section">
                <div className="container smallestwdt">
                    <div className="greenlft">
                        <img src={Greenlogo} alt="greenlogo" loading="lazy" />
                    </div>

                    <div className="greenrgt">
                        <h2
                            className="bluetxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.open_play_green_products_title,
                            }}
                        />
                        <p
                            className="biggertxt lastitem"
                            dangerouslySetInnerHTML={{
                                __html:
                                    post.acf.open_play_green_products_content,
                            }}
                        />
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default openplay;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            acf {
                open_play_basic_info_content
                open_play_basic_info_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                srcWebp
                                src
                            }
                        }
                    }
                }
                open_play_basic_info_title
                open_play_content_right
                open_play_content_second
                open_play_green_products_content
                open_play_green_products_title
                open_play_image_left {
                    localFile {
                        childImageSharp {
                            fluid {
                                srcWebp
                                src
                            }
                        }
                    }
                }
                open_play_membership_description
                open_play_membership_list {
                    open_play_membership_name
                    open_play_membership_price
                }
                open_play_membership_title
                open_play_please_call_ahead_text
                open_play_registration_title
                open_play_register_widget_codes {
                    open_play_register_widget_code
                }
                open_play_schedule_title
                open_play_schedule_work_days {
                    open_play_schedule_day
                    open_play_schedule_time
                }
                open_play_schedule_weekend {
                    open_play_schedule_weekend_day
                    open_play_schedule_weekend_time
                }
            }
        }
    }
`;
